export const AOI_TMO_TABLE_HEADERS = [
  {
    headerName: 'ID',
    key: 'leadId'
  },
  {
    headerName: 'Company Name',
    key: 'customerName'
  },
  {
    headerName: 'Order Status',
    key: 'status'
  },
  {
    headerName: 'Number Of Sites',
    key: 'numberOfSites'
  },
  {
    headerName: 'Action',
    key: 'action'
  }
];
